
// LegalIndex.js
//
// The bare "/legal" page — a small resource hub pointing to the actual
// legal documents, rather than a document itself. See LegalHeader for the
// shared title block and LegalResourceCard for the Privacy/Terms cards.

import React from 'react';

import { LuShieldCheck, LuFileText } from 'react-icons/lu';

import LegalHeader from '../components/legalcomponents/LegalHeader';
import LegalResourceCard from '../components/legalcomponents/LegalResourceCard';
import TitleField from '../components/text/TitleField';
import TextField from '../components/text/TextField';

import '../styles/legalcomponents/LegalIndex.css';

const LegalIndex = () => {

    return (
        <>
            <LegalHeader
                eyebrow="Legal"
                title="Legal & Privacy"
                description="Information about the policies that govern our website, privacy practices, and business relationships."
            />

            <div className="legal-index-container">

                <section className="legal-index-group">
                    <TextField
                        className="legal-index-group-label"
                        text="Website Policies"
                        bold={true}
                        fontSize="0.8rem"
                        fontColor="#5a7a1a"
                    />

                    <div className="legal-resource-cards-row">
                        <LegalResourceCard
                            icon={LuShieldCheck}
                            title="Privacy Policy"
                            description="Learn how NicheWare collects, uses, and protects personal information."
                            ctaText="Read Privacy Policy"
                            to="/legal/privacy-policy"
                        />

                        <LegalResourceCard
                            icon={LuFileText}
                            title="Website Terms of Use"
                            description="Understand the terms that apply when using the NicheWare website."
                            ctaText="Read Terms of Use"
                            to="/legal/terms-of-service"
                        />
                    </div>
                </section>

                <section className="legal-index-group">
                    <TextField
                        className="legal-index-group-label"
                        text="Business & Services"
                        bold={true}
                        fontSize="0.8rem"
                        fontColor="#5a7a1a"
                    />

                    <div className="legal-index-plain-block">
                        <TitleField title="Client Agreements" bold={true} fontSize="1.25rem"/>

                        <TextField
                            text="NicheWare software development, subscriptions, implementation, support, and other commercial services may be governed by separate written agreements with the applicable client. The Website Terms of Use above do not replace or modify those agreements."
                            fontColor="#555555"
                        />
                    </div>
                </section>

                <section className="legal-index-group">
                    <TextField
                        className="legal-index-group-label"
                        text="Contact"
                        bold={true}
                        fontSize="0.8rem"
                        fontColor="#5a7a1a"
                    />

                    <div className="legal-index-contact-grid">
                        <div className="legal-index-contact-item">
                            <TitleField title="Legal or Terms Questions" bold={true} fontSize="1.05rem"/>
                            <TextField text="jeannicolasrouette@nicheware.ca" fontColor="#555555"/>
                        </div>

                        <div className="legal-index-contact-item">
                            <TitleField title="Privacy Questions" bold={true} fontSize="1.05rem"/>
                            <TextField text="jeannicolasrouette@nicheware.ca" fontColor="#555555"/>
                        </div>

                        <div className="legal-index-contact-item">
                            <TitleField title="Location" bold={true} fontSize="1.05rem"/>
                            <TextField text="Calgary, Alberta, Canada" fontColor="#555555"/>
                        </div>

                        <div className="legal-index-contact-item">
                            <TitleField title="Legal Business Name" bold={true} fontSize="1.05rem"/>
                            <TextField text="NicheWare" fontColor="#555555"/>
                        </div>
                    </div>

                    <p className="legal-index-contact-note">
                        You can also reach us anytime through our <a href="/contact">Contact page</a>.
                    </p>
                </section>

            </div>
        </>
    );
};

export default LegalIndex;
